import React from 'react';
import { DrawerConstellation } from '../../../../constellationExtended/SideDrawer/DrawerConstellation';
import { Heading, TextButton } from '@zillow/constellation';
import { RecentOrdersTable } from './RecentOrdersTable';

export const RecentOrdersDrawer: React.FC = () => {
  return (
    <DrawerConstellation
      renderHeader={<Heading level={6}>Recent Orders</Heading>}
      renderBody={<RecentOrdersTable />}
      triggerElement={<TextButton>My Recent Orders</TextButton>}
      backdrop={null}
      size={'sm'}
    />
  );
};
